const ACTIVE_CLASS_MENU = 'Header__menu--active';
const ACTIVE_CLASS_HAMBURGER = 'Hamburger--open';

const hamburgerBtn = document.getElementById('toggle');
const navigation = document.querySelector('.Header__menu');

const closeAllNavigations = () => {
    document.querySelectorAll('.Navigation ul.open').forEach((nav) => nav.classList.remove('open'));
};

const query = window.matchMedia('(max-width: 1024px)');

const handleSetOverflow = () => {
    if (query.matches) {
        if (!navigation.classList.contains(ACTIVE_CLASS_MENU)) {
            document.documentElement.style.overflowY = 'auto';
            closeAllNavigations();
        } else {
            document.documentElement.style.overflowY = 'hidden';
        }
    } else {
        document.documentElement.style.overflowY = 'auto';
    }
};

const toggleMenu = (ev) => {
    hamburgerBtn.classList.toggle(ACTIVE_CLASS_HAMBURGER);
    // ev.currentTarget.classList.toggle(ACTIVE_CLASS_HAMBURGER);
    navigation?.classList.toggle(ACTIVE_CLASS_MENU);

    handleSetOverflow();
};

hamburgerBtn?.addEventListener('click', toggleMenu);

query.addEventListener('change', handleSetOverflow);

if (window.innerWidth < 1024) {
    const subMenuItems = document.querySelectorAll('.Navigation__subMenuLink');
    if (subMenuItems.length > 0) {
        subMenuItems.forEach((item) => {
            item.addEventListener('click', (ev) => {
                const ul = item.parentElement.querySelector('ul');
                if (!ul) {
                    toggleMenu();
                }
            });
        });
    }
}

if (window.innerWidth > 1023) {
    function updateStyles() {
        const mega_menu = document.querySelectorAll('.mega_menu');
        const menu__wrapper = document.querySelector('.menu__wrapper');

        mega_menu.forEach((menu) => {
            const pozycjaOjca = menu.getBoundingClientRect();
            const roznicaOdLewej = pozycjaOjca.left;

            const child = menu.querySelector('.Navigation__subMenu');
            const width = menu__wrapper.offsetWidth;

            if (window.innerWidth > 1023) {
                const paddingValue = `calc((100vw - ${width}px) / 2)`;

                child.style.left = `-${roznicaOdLewej}px`;
                child.style.paddingLeft = `${paddingValue}`;
                child.style.paddingRight = `${paddingValue}`;
            } else {
                // Przywróć domyślne style, jeśli szerokość ekranu jest mniejsza lub równa 1023px
                child.style.left = 'auto';
                child.style.paddingLeft = '0';
                child.style.paddingRight = '0';
            }
        });
    }

    // Wywołaj funkcję po załadowaniu strony i podczas zmiany szerokości okna
    window.addEventListener('load', updateStyles);
    window.addEventListener('resize', updateStyles);
}
